import { render, staticRenderFns } from "./zhDepatrTree.vue?vue&type=template&id=35f1bad8&scoped=true&"
import script from "./zhDepatrTree.vue?vue&type=script&lang=js&"
export * from "./zhDepatrTree.vue?vue&type=script&lang=js&"
import style0 from "./zhDepatrTree.vue?vue&type=style&index=0&id=35f1bad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1bad8",
  null
  
)

export default component.exports